import type { GeomTypeUtil } from "./geomTypeUtil";
import type BoundsUtil from "../../boundsUtil";
import type MatrixUtil from "../../matrixUtil";
import type GeomUtil from "../geomUtil";

/**
 * Geometry functions for multi line strings
 */
export default class ML implements GeomTypeUtil {
    private readonly boundsUtil: BoundsUtil;
    private readonly geomUtil: GeomUtil;
    private readonly matrixUtil: MatrixUtil;

    constructor(boundsUtil: BoundsUtil, geomUtil: GeomUtil, matrixUtil: MatrixUtil) {
        this.boundsUtil = boundsUtil;
        this.geomUtil = geomUtil;
        this.matrixUtil = matrixUtil;
    }

    /**
     * 
     * @param geom 
     * @param callback 
     * @param owner 
     */
    extractPoints(geom: any[], callback: Function, owner?: any) {
        for (let g = geom.length; g-- > 1; ) {
            const lineString = geom[g];

            for (let s = lineString.length - 2; s >= 2; s -= 2) {
                callback.call(owner, lineString, s);
            }
        }
    }
    
    /**
     * 
     * @param geom 
     * @param callback 
     * @param owner 
     */
    extractLines(geom: any[], callback: Function, owner?: any) {
        for (let g = geom.length; g-- > 1; ) {
            const lineString = geom[g];
            callback.call(owner, lineString, 0, lineString.length);
        }
    }
    
    /**
     * 
     * @param geom 
     * @param bounds 
     * 
     * @returns 
     */
    getBounds(geom: any[], bounds: number[]): number[] {
        for (let g = 1; g < geom.length; g++) {
            bounds = this.boundsUtil.valueOf(geom[g], bounds);
        }

        return bounds;
    }
    
    /**
     * 
     * @param geom 
     * @param matrix 
     * 
     * @returns 
     */
    transform(geom: any[], matrix: any[]): any[] {
        const ret: any[] = ["ML"];
        for (let g = 1; g < geom.length; g++) {
            const lineString = geom[g];
            ret[g] = this.matrixUtil.transform(matrix, lineString, 0, lineString.length);
        }

        return ret;
    }

    /**
     * 
     * @param geom 
     * @param threshold 
     * 
     * @returns 
     */
    generalize(geom: any[], threshold: number): any[] {
        const ret: any[] = ["ML"];
        for (let g = 1; g < geom.length; g++) {
            ret.push(this.geomUtil.generalizeLines(geom[g], 0, null, threshold));
        }

        return ret;
    }
}
